import FormTitle from '@core/components/FormTitle';
import { RangeDateInput } from '@core/components/Inputs';
import IpsInput from '@core/components/Inputs/IpsInput';
import { Collapse, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Switch } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';
import Restricoes from './Restricoes';
import { useRestricoesUsuarioStyles } from './styles';

const TabRestricoesUsuario = () => {
  const formik = useFormikContext();

  const styles = useRestricoesUsuarioStyles();

  const _errors = {
    restricoes: {
      periodoAcessoInicio:
        (formik.touched.periodoAcessoInicio || formik.submitCount > 0) && formik.errors.periodoAcessoInicio,
    },
  };

  return (
    <>
      <FormTitle title="Informações para acesso" />
      <Grid container spacing={3} className="mb-16">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControlLabel
            control={
              <Switch
                id="restricoes.configurarPeriodo"
                name="restricoes.configurarPeriodo"
                value={formik.values.restricoes?.configurarPeriodo}
                checked={formik.values.restricoes?.configurarPeriodo}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                color="primary"
              />
            }
            label="Configurar período"
          />
          <Collapse in={!!formik.values.restricoes?.configurarPeriodo}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="mt-8">
              <RangeDateInput
                id="restricoes.periodoAcessoInicio"
                name="restricoes.periodoAcessoInicio"
                value={[formik.values.restricoes?.periodoAcessoInicio, formik.values.restricoes?.periodoAcessoFim]}
                label="Período de acesso"
                error={!!_errors.restricoes?.periodoAcessoInicio}
                helperText={_errors.restricoes?.periodoAcessoInicio}
                onBlur={formik.handleBlur}
                required
                onChange={(inicio, fim) => {
                  formik.setFieldValue('restricoes.periodoAcessoFim', fim);
                  formik.setFieldValue('restricoes.periodoAcessoInicio', inicio);
                }}
              />
            </Grid>
          </Collapse>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt-8">
            <FormControl
              id="restricoes.periodoHorarioAcesso"
              name="restricoes.periodoHorarioAcesso"
              component="fieldset"
              onChange={formik.handleChange}
            >
              <FormLabel component="legend" className={styles.label}>
                Em qual momento do dia o usuário poderá acessar o sistema:
              </FormLabel>
              <RadioGroup
                defaultValue="QUALQUER_MOMENTO"
                value={formik.values.restricoes.periodoHorarioAcesso}
                name="restricoes.periodoHorarioAcesso"
              >
                <FormControlLabel
                  value="QUALQUER_MOMENTO"
                  control={<Radio color="primary" />}
                  label="A qualquer momento"
                />
                <FormControlLabel
                  value="HORARIO_COMERCIAL"
                  control={<Radio color="primary" />}
                  label="Horário comercial, segunda-feira a sexta-feira, 08 às 18h"
                />
                <FormControlLabel
                  value="CUSTOMIZADO"
                  control={<Radio color="primary" />}
                  label="Selecionar dia(s) e horário(s)"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Collapse in={formik.values.restricoes?.periodoHorarioAcesso === 'CUSTOMIZADO'}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt-8">
              <Restricoes
                id="restricoes"
                name="restricoes"
                onChange={formik.handleChange}
                values={formik.values.restricoes}
              />
            </Grid>
          </Collapse>
        </Grid>
      </Grid>

      <FormTitle title="IP's válidos para acesso" />

      <IpsInput
        id="restricoes.ips"
        name="restricoes.ips"
        values={formik.values.restricoes?.ips}
        onChange={formik.handleChange}
      />
    </>
  );
};

export default TabRestricoesUsuario;
